import React from 'react';
import './TagFilter.css';

function TagFilter({ tags, selectedTag, onTagClick }) {
  if (!tags || tags.length === 0) {
    return null;
  }

  return (
    <div className="tag-filter">
      <h3>Filter by Tag:</h3>
      <div className="tag-filter-list">
        {tags.map((tag, index) => (
          <button
            key={index}
            className={`filter-tag ${selectedTag === tag.name ? 'active' : ''}`}
            onClick={() => onTagClick(tag.name)}
          >
            {tag.name} <span className="tag-count">({tag.count})</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default TagFilter;
